<template>
  <j-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    switchFullscreen
    :fullscreen="true"
    @cancel="handleCancel">

    <template slot="footer">
      <a-button key="cancel" @click="handleCancel">关闭</a-button>
      <a-button v-if="!disableSubmit" key="submit" @click="handleOk" type="primary" :loading="confirmLoading">提交
      </a-button>
    </template>

    <a-spin :spinning="confirmLoading">
      <!-- 主表单区域 -->
      <a-form :form="form">
        <a-row>

          <a-col :xs="24" :sm="12">
            <a-form-item label="商品编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['prodCode']" placeholder="请输入商品编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item label="商品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="readOnly" v-decorator="['prodName']" placeholder="请输入商品名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item label="商品品类" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['prodType',validatorRules.prodType]"
                                 :trigger-change="true" placeholder="请选择商品品类"
                                 dict-code="manufacture_product_category,name,id,is_enabled=1"
                                 :disabled="readOnly"></j-dict-select-tag>
            </a-form-item>
          </a-col>
<!--          <a-col :xs="24" :sm="12">-->
<!--            <a-form-item label="商品规格" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-dict-select-tag type="list" v-decorator="['prodSpecs', validatorRules.prodSpecs]"-->
<!--                                 :trigger-change="true" placeholder="请选择商品规格" ref="prodSpecsComp"-->
<!--                                 dict-code="manufacture_product_specs,spec_name,id" :disabled="readOnly"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xs="24" :sm="12">-->
<!--            <a-form-item label="商品属性" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-multi-select-tag type="list_multi" v-decorator="['prodProps', validatorRules.prodProps]"-->
<!--                                  :trigger-change="true" placeholder="请选择商品属性" ref="prodPropsComp"-->
<!--                                  dict-code="manufacture_product_props,prop_name,id" :disabled="readOnly"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :xs="24" :sm="12">
            <a-form-item label="商品状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['prodState', validatorRules.prodState]"
                                 :trigger-change="true"
                                 dictCode="dict_item_status" placeholder="请选择商品状态" :disabled="readOnly"
              />
            </a-form-item>
          </a-col>
<!--          <a-col :xs="24" :sm="12">-->
<!--            <a-form-item label="商品图片" :labelCol="labelCol" :wrapperCol="wrapperCol" help="至少上传1张图片，且最多不超过3张">-->
<!--              <j-image-upload ref="proPicComp" isMultiple v-decorator="['prodPic',validatorRules.prodPic]"-->
<!--                              :disabled="readOnly" @change="handleProPicChange($event)"></j-image-upload>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :xs="24" :sm="12">
            <a-form-item label="创建人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['createBy']" placeholder="请输入创建人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item label="创建日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date disabled placeholder="请选择创建日期" v-decorator="['createTime']" :trigger-change="true"
                      :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item label="更新人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['updateBy']" placeholder="请输入更新人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item label="更新日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date disabled placeholder="请选择更新日期" v-decorator="['updateTime']" :trigger-change="true"
                      :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item label="销售价格" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="readOnly" v-decorator="['prodPrice']" placeholder="请输入销售价格"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <!-- 子表单区域 -->
      <a-tabs v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane tab="商品管理-物料消耗（BOM）" :key="refKeys[0]" :forceRender="true">
          <span>此清单将在售出商品时对门店仓库物料进行扣减</span>
          <j-editable-table
            :ref="refKeys[0]"
            :loading="manufactureProductMaterialTable.loading"
            :columns="manufactureProductMaterialTable.columns"
            :dataSource="manufactureProductMaterialTable.dataSource"
            :maxHeight="300"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="true">

            <template v-slot:batchNoSelectModal="props" style="padding-left: 0">
              <a-button :disabled="readOnly" @click="handleBatchNoSelect(props)" icon="ellipsis"></a-button>
              <onl-cgreport-select-modal
                ref="selectModal"
                title="选择物料"
                reportId="1393482678581661698"
                :width="1100"
                :multiSelectable="true"
                :params = "materialReportParam"
                @callback="(selectedRows)=>handleBatchNoSelectCallback(props,selectedRows)"/>
            </template>

          </j-editable-table>
        </a-tab-pane>

      </a-tabs>

    </a-spin>
  </j-modal>
</template>

<script>

  import pick from 'lodash.pick'
  import {FormTypes, getRefPromise} from '@/utils/JEditableTableUtil'
  import {JEditableTableMixin} from '@/mixins/JEditableTableMixin'
  import JDate from '@/components/jeecg/JDate'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JMultiSelectTag from "@/components/dict/JMultiSelectTag"
  import JTreeSelect from "@/components/jeecg/JTreeSelect"
  import {putAction,postAction} from "@/api/manage";
  import OnlCgreportSelectModal from '../../components/OnlCgreportSelectModal'

  export default {
    name: 'ManufactureProductModal',
    mixins: [JEditableTableMixin],
    components: {
      JDate,
      JImageUpload,
      JDictSelectTag,
      JMultiSelectTag,
      JTreeSelect,
      OnlCgreportSelectModal
    },
    data() {
      return {
        module_sign:"sales_order",
        action: '',
        materialReportParam : {storeId:'1'},
        proPicMaxUpload: 3,
        labelCol: {
          xs: {span: 24},
          sm: {span: 6},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        labelCol2: {
          xs: {span: 24},
          sm: {span: 3},
        },
        wrapperCol2: {
          xs: {span: 24},
          sm: {span: 20},
        },
        disableSubmit: false,
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          prodType: {
            rules: [
              {required: true, message: '请输入商品品类!'},
            ]
          },
          prodSpecs: {
            rules: [
              {required: true, message: '请输入商品规格!'},
            ]
          },
          prodProps: {
            rules: [
              {required: true, message: '请输入商品规格!'},
            ]
          },
          prodPic: {
            rules: [
              {required: true, message: '请上传商品图片!'},
            ]
          },
          prodState: {
            rules: [
              {required: true, message: '请输入商品状态!'},
            ]
          }
        },
        refKeys: ['manufactureProductMaterial',],
        tableKeys: ['manufactureProductMaterial',],
        activeKey: 'manufactureProductMaterial',
        // 商品管理-物料消耗
        manufactureProductMaterialTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '物料信息',
              key: 'materialInfo',
              type: FormTypes.sel_search,
              dictCode: "bas_material,name,id",
              width: "200px",
              placeholder: '请输入${title}',
              validateRules: [{required: true, message: '${title}不能为空'}],
              disabled: true,
            },
            {
              title: '',
              key: 'batchNoSelectModal',
              type: FormTypes.slot,
              slotName: 'batchNoSelectModal',
              orgFields: "id,unit_id",
              destFields: "materialInfo,consumerUnitId",
              width:"45px",
            },
            {
              title: '物料消耗单位',
              key: 'consumerUnitId',
              type: FormTypes.select,
              dictCode: "bas_measure_unit,name,id",
              width: "200px",
              placeholder: '请输入${title}',
            },
            {
              title: '物料消耗数量',
              key: 'materialConsume',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              validateRules: [{required: true, message: '${title}不能为空'}],
            }
          ]
        },
        url: {
          add: "/manufacture/manufactureProduct/add",
          edit: "/manufacture/manufactureProduct/edit",
          manufactureProductMaterial: {
            list: '/manufacture/manufactureProduct/queryManufactureProductMaterialByMainId'
          },
          batchGetMapperUnitIdBySign: "/bas/basMaterial/batchGetMapperUnitIdBySign",
        }
      }
    },
    computed: {
      readOnly: function () {
        return this.action !== "add" && this.action !== "edit";
      }
    },
    updated() {
      this.$nextTick(() => {
        // 设置商品图片达到上传上限，不允许上传
        this.handleProPicChange(this.form.getFieldValue('prodPic'));
      })
    },
    methods: {
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      addInit() {
        // 新增初始化操作
        // 生成商品编号
        const that = this
        const url = '/sys/fillRule/executeRuleByCode/'
        const ruleCode = 'prod_no'
        putAction(url + ruleCode, {}).then(res => {
          if (res.success) {
            that.$nextTick(() => {
              that.form.setFieldsValue({'prodCode': res.result})
            })
          }
        })
        // 设置商品状态字段默认值
        this.model.prodState = 1
        this.manufactureProductMaterialTable.dataSource = [];
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        if (this.action === 'add') {
          this.addInit()
        }
        let fieldval = pick(this.model, 'createBy', 'createTime', 'updateBy', 'updateTime', 'prodCode', 'prodName', 'prodType', 'prodSpecs', 'prodProps', 'prodState', 'prodPic','prodPrice')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
          // 加载子表数据
          if (this.model.id) {
            let params = {id: this.model.id}
            this.requestSubTableData(this.url.manufactureProductMaterial.list, params, this.manufactureProductMaterialTable)
            // this.manufactureProductMaterialTable.columns.every(column => {
            //   column.disabled = that.readOnly
            // })
          }
        })
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          manufactureProductMaterialList: allValues.tablesValue[0].values,
        }
      },
      validateError(msg) {
        this.$message.error(msg)
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'createBy', 'createTime', 'updateBy', 'updateTime', 'prodCode', 'prodName', 'prodType', 'prodSpecs', 'prodProps', 'prodState', 'prodPic','prodPrice'))
      },
      handleProPicChange(event) {
        if (event) {
          let picArray = event.split(',')
          if (picArray.length >= this.$data.proPicMaxUpload) {
            this.$refs.proPicComp.$children[0].$children[1].disabled = true
          }
        }
      },
      handleBatchNoSelect(props) {
        let row = props.getValue();
        let orgFields = props.column.orgFields.split(',');
        let destFields = props.column.destFields.split(',');
        let queryParams = {};
        for (let i = 0; i < orgFields.length; i++) {
          queryParams[orgFields[i]] = row[destFields[i]];
        }
        this.$refs.selectModal.initQueryParams(queryParams);
        this.$refs.selectModal.visible = true;
      },
      handleBatchNoSelectCallback(props, selectedRows) {
        if (selectedRows) {
          let valArr = [];
          for (let i = 0; i < selectedRows.length; i++) {
            let materialId = selectedRows[i].id;
            let unitId = selectedRows[i].unit_id;
            valArr.push({"materialId": materialId, "unitId": unitId});
          }
          if (valArr) {
            postAction(this.url.batchGetMapperUnitIdBySign, {
              data: valArr,
              moduleSign: this.module_sign
            }).then((res) => {
              if (res.success) {
                let newData = res.result;
                //将查询的新计量单位插入selectedRows
                for (let z = 0; z < selectedRows.length; z++) {
                  let orgMaterialId = selectedRows[z].id;
                  for (let w = 0; w < newData.length; w++) {
                    let targetMaterialId = newData[w].materialId;
                    if (orgMaterialId === targetMaterialId) {
                      let newUnitId = newData[w].unitId;
                      selectedRows[z].unit_id = newUnitId;
                      break;
                    }
                  }
                }
                let {rowId, target} = props;
                let orgFields = props.column.orgFields.split(',');
                let destFields = props.column.destFields.split(',');
                for (let i = 0; i < selectedRows.length; i++) {
                  let values = {};
                  for (let j = 0; j < orgFields.length; j++) {
                    values[destFields[j]] = selectedRows[i][orgFields[j]];
                  }

                  if (i === 0) {
                    target.setValues([{rowKey: rowId, values: values}]);
                  } else {
                    target.add();
                    let rowId2 = target.rows[target.rows.length - 1].id;
                    target.setValues([{rowKey: rowId2, values: values}]);
                  }
                }
              }
            })
          }
        }
      }
    }
  }
</script>

<style scoped>
</style>